import Vue from "vue";

import UniversalButton from "@/../../shared/app/components/gui/UniversalButton";
import UniversalDialog from "@/../../shared/app/components/gui/UniversalDialog";
import UniversalDataTable from "@/../../shared/app/components/gui/UniversalDataTable";
import UniversalListAvatar from "@/../../shared/app/components/gui/UniversalListAvatar";

import FormTextInput from "@/../../shared/app/components/gui/FormTextInput";
import FormFileInput from "@/../../shared/app/components/gui/FormFileInput";
import FormSelect from "@/../../shared/app/components/gui/FormSelect";
import FormTextArea from "@/../../shared/app/components/gui/FormTextArea";
import FormCheckBox from "@/../../shared/app/components/gui/FormCheckBox";
import FormDateSelectorField from "@/../../shared/app/components/gui/FormDateSelectorField";
import FormAutocomplete from "@/../../shared/app/components/gui/FormAutocomplete";
import FormTextDatePicker from "@/../../shared/app/components/gui/FormTextDatePicker";

import MessageBox from "@/../../shared/app/components/gui/MessageBox";
import YesNoDialog from "@/../../shared/app/components/gui/YesNoDialog";
import SetString from "@/../../shared/app/components/gui/SetString";
import SetStringWithSelect from "@/../../shared/app/components/gui/SetStringWithSelect";
import SetTitleAndColor from "@/../../shared/app/components/gui/SetTitleAndColor";
import SetCurrency from "@/../../shared/app/components/gui/SetCurrency";
import SetNumber from "@/../../shared/app/components/gui/SetNumber";
import SetDate from "@/../../shared/app/components/gui/SetDate";
import Calendar from "@/../../shared/app/components/gui/Calendar";

Vue.component("UniversalButton", UniversalButton);
Vue.component("UniversalDialog", UniversalDialog);
Vue.component("UniversalDataTable", UniversalDataTable);
Vue.component("UniversalListAvatar", UniversalListAvatar);

Vue.component("FormTextInput", FormTextInput);
Vue.component("FormFileInput", FormFileInput);
Vue.component("FormSelect", FormSelect);
Vue.component("FormTextArea", FormTextArea);
Vue.component("FormCheckBox", FormCheckBox);
Vue.component("FormDateSelectorField", FormDateSelectorField);
Vue.component("FormAutocomplete", FormAutocomplete);
Vue.component("FormTextDatePicker", FormTextDatePicker);
Vue.component("MessageBox", MessageBox);
Vue.component("YesNoDialog", YesNoDialog);
Vue.component("SetString", SetString);
Vue.component("SetDate", SetDate);
Vue.component("SetStringWithSelect", SetStringWithSelect);
Vue.component("SetTitleAndColor", SetTitleAndColor);
Vue.component("SetNumber", SetNumber);
Vue.component("SetCurrency", SetCurrency);

Vue.component("Calendar", Calendar);
